import React, { useState } from 'react';
import { Notification } from 'common/notification';
import styles from './reset-password.module.scss';
import { ResetPasswordStep1 } from './components/reset-password-step-1';
import { ResetPasswordStep2 } from './components/reset-password-step-2';

type ResetPasswordProps = {
  onClickBack: () => void;
};

const ResetPassword: React.FC<ResetPasswordProps> = ({ onClickBack }) => {
  const [showError, setShowError] = useState(false);
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(0);

  const showErrorNotification = () => (
    <Notification handleClose={() => setShowError(false)} />
  );

  const showResetPasswordStep1 = () => (
    <ResetPasswordStep1
      notifSuccess={() => setStep(1)}
      email={email}
      setEmail={setEmail}
      onClickBack={onClickBack}
    />
  );

  const handleBack = () => {
    setStep(0);
    setEmail('');
  };

  const showResetPasswordStep2 = () => (
    <ResetPasswordStep2
      email={email}
      notifGoBack={handleBack}
      backToLogin={onClickBack}
    />
  );

  const showContent = () => (
    <>
      {step === 0 && showResetPasswordStep1()}
      {step === 1 && showResetPasswordStep2()}
    </>
  );

  return (
    <div className={styles.container}>
      {showError && showErrorNotification()}
      {showContent()}
    </div>
  );
};

export { ResetPassword };
